module.exports = {
  label: {
    name: 'Name of patient',
    phoneNumber: 'Mobile',
    emailId: 'Email',
    nodata:'----',
    noDataFound:'No Data Found',
    error:'Something Went Wrong',
    receivedDate: 'Received date',
    buttons:{
      createScript:"Create script / document",
      createEScript:"Create e-script / e-document"
    }
  }
};
